(function($){

	$(document).ready(function(){

		new Index();
	});


}(jQuery));
